import React from "react";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import RequestGetList from "../components/common/requestForm/RequestGetList";
import {
  FaComment,
  FaPhotoVideo,
  FaRegEdit,
  FaRegFileAlt,
} from "react-icons/fa";
import { useState } from "react";
import Loading from "../components/common/Loading";
import CreateProductForm from "../components/common/forms/EditProductForm";
import CreateBrandForm from "../components/common/forms/CreateBrandForm";
import EditBrandForm from "../components/common/forms/EditBrandForm";
import Quill from "quill";
import CreateBlogForm from "../components/common/forms/CreateBlogForm";
import EditBlogForm from "../components/common/forms/EditBlogForm";
import EditTimerProduct from "../components/common/forms/EditTimerProduct";
import EditSliderBlogs from "../components/common/forms/EditSliderBlogs";
import EditVideoBlog from "../components/common/forms/EditVideoBlog";
import EditImgBlog from "../components/common/forms/EditImgBlog";
import CreateBlogCategoryForm from "../components/common/forms/CreateBlogCategoryForm";
import EditBlogCategoryForm from "../components/common/forms/EditBlogCategoryForm";
import EditCommentBlogForm from "../components/common/forms/EditCommentBlogForm";

const BlogManagePage = () => {
  const [editing, setEditing] = useState();
  const [creating, setCreating] = useState();
  const [slider, setslider] = useState();
  const [video, setvideo] = useState();
  const [createCategory, setcreateCategory] = useState();
  const [editCategory, seteditCategory] = useState();
  const [img, setimg] = useState();
  const [comment, setcomment] = useState();
  const [loading, setLoading] = useState();

  async function handleCreateShow(params) {
    setCreating(true);
  }
  async function handleEditShow(params) {
    setEditing(true);
  }
  async function handleSlider(params) {
    setslider(true);
  }

  async function handleVideo(params) {
    setvideo(true);
  }

  async function handleImg(params) {
    setimg(true);
  }

  async function handleComment(params) {
    setcomment(true);
  }

  async function handleCreate(params) {
    setcreateCategory(true);
  }

  async function handleEdit(params) {
    seteditCategory(true);
  }

  function handleBack() {
    setCreating(false);
    setEditing(false);
    setslider(false);
    setvideo(false);
    setimg(false);
    setcreateCategory(false);
    seteditCategory(false);
    setcomment(false);
  }

  if (loading) {
    return <Loading />;
  }
  return (
    <div className="w-full">
      <h1 className="title mb-10">مدیریت بلاگ ها</h1>
      {!editing &&
        !creating &&
        !slider &&
        !video &&
        !img &&
        !createCategory &&
        !editCategory &&
        !comment && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <span className="col-span-full">
              <p className="text-center font-bold text-[28px]">
                چه کاری میخوای انجام بدی؟
              </p>
            </span>
            <span
              onClick={handleCreateShow}
              className="border-brand p-5 flex justify-between items-center hover:bg-black hover-text-secendory cursor-pointer duration-300"
            >
              <p className="text-center font-bold text-[20px]">
                ایجاد بلاگ جدید
              </p>
              <FaRegFileAlt
                size={45}
                color="#000"
                className="bg-white p-1 rounded-[10px]"
              />
            </span>
            <span
              onClick={handleEditShow}
              className="border-brand p-5 flex justify-between items-center hover:bg-black hover-text-secendory cursor-pointer duration-300"
            >
              <p className="text-center font-bold text-[20px]">
                تغییر بلاگ های موجود
              </p>
              <FaRegEdit
                size={45}
                color="#000"
                className="bg-white p-1 rounded-[10px]"
              />
            </span>
            <span
              onClick={handleCreate}
              className="border-brand p-5 flex justify-between items-center hover:bg-black hover-text-secendory cursor-pointer duration-300"
            >
              <p className="text-center font-bold text-[20px]">
                ایجاد دسته بندی بلاگ
              </p>
              <FaRegFileAlt
                size={45}
                color="#000"
                className="bg-white p-1 rounded-[10px]"
              />
            </span>
            <span
              onClick={handleEdit}
              className="border-brand p-5 flex justify-between items-center hover:bg-black hover-text-secendory cursor-pointer duration-300"
            >
              <p className="text-center font-bold text-[20px]">
                تغییر دسته بندی بلاگ
              </p>
              <FaRegEdit
                size={45}
                color="#000"
                className="bg-white p-1 rounded-[10px]"
              />
            </span>
          </div>
        )}

      {(editing ||
        creating ||
        slider ||
        video ||
        img ||
        createCategory ||
        editCategory ||
        comment) && (
        <>
          <button onClick={handleBack} className="btn-brand mb-10">
            بازگشت
          </button>
          <br />
        </>
      )}

      {creating && <CreateBlogForm />}
      {slider && <EditSliderBlogs />}
      {editing && <EditBlogForm />}
      {video && <EditVideoBlog />}
      {img && <EditImgBlog />}
      {createCategory && <CreateBlogCategoryForm />}
      {editCategory && <EditBlogCategoryForm />}
      {comment && <EditCommentBlogForm />}
    </div>
  );
};

export default BlogManagePage;
